import sumBy from "lodash/sumBy";
import config from "services/config";

const { apiBaseURL } = config;
export const productImageSrc = (product) => {
	return `${apiBaseURL}/users/v1/products/${product.id}/image/${product.imageSrc}/public`;
};

export const sumItemQuantity = (items) => {
	return sumBy(items, "quantity");
};
